import cn from "classnames";
import { FC, Fragment } from "react";
import type {
  CaseStudyStatsProps,
} from "./CaseStudyStats.types";
import { CaseStudyStatsDesktop } from "./CaseStudyStatsDesktop";
import { CaseStudyStatsMobile } from "./CaseStudyStatsMobile";

const CaseStudyStats: FC<CaseStudyStatsProps> = ({
  className,
  ...rest
}) => {
  return (
    <Fragment>
      <CaseStudyStatsMobile
        {...rest}
        className={cn("md:hidden", className)}
      />
      <CaseStudyStatsDesktop
        {...rest}
        className={cn("hidden md:block", className)}
      />
    </Fragment>
  );
};

export { CaseStudyStats };
